import React from 'react';
import TabLineContainer from '../../Componant/UiKits/Tabs/LineTab';

const TabLine = () => {
  return (
    <div className='page-body'>
      <TabLineContainer />
    </div>
  );
};

export default TabLine;
